import { useState } from "react";
import { P, FF } from "../../styles/tokens";
import { useSubscription } from "../../hooks/useSubscription";
import { useToast } from "../../contexts/ToastContext";

function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("es-MX", { day: "numeric", month: "long", year: "numeric" });
}

/**
 * Banner global que aparece en la parte superior de toda la app
 * cuando la cuenta está en estado pending_deletion.
 */
export default function DeletionBanner() {
  const { subscription, loading, cancelDeletion } = useSubscription();
  const { show: showToast } = useToast();
  const [working, setWorking] = useState(false);

  // No renderizar nada mientras carga o si no hay pending_deletion
  if (loading || !subscription) return null;
  if (subscription.status !== "pending_deletion") return null;

  const deletionAt = subscription.deletion_scheduled_for;

  async function handleCancel() {
    setWorking(true);
    try {
      await cancelDeletion();
      showToast("✓ Eliminación cancelada. Tu cuenta está activa.");
    } catch (e) {
      showToast("Error al cancelar eliminación: " + (e.message || "intenta de nuevo"));
    } finally {
      setWorking(false);
    }
  }

  return (
    <div
      role="alert"
      style={{
        background: P.danger.base,
        color: "#fff",
        padding: "10px 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        flexWrap: "wrap",
        fontFamily: FF,
        fontSize: 13,
        fontWeight: 600,
        zIndex: 50,
        position: "relative",
      }}
    >
      <span>
        ⚠️ Tu cuenta será eliminada el <strong>{fmtDate(deletionAt)}</strong>.
      </span>
      <button
        onClick={handleCancel}
        disabled={working}
        style={{
          padding: "6px 14px",
          borderRadius: 8,
          border: "1.5px solid rgba(255,255,255,0.6)",
          background: "rgba(255,255,255,0.15)",
          color: "#fff",
          fontFamily: FF,
          fontSize: 12,
          fontWeight: 700,
          cursor: working ? "default" : "pointer",
          opacity: working ? 0.7 : 1,
          whiteSpace: "nowrap",
          transition: "background .15s",
        }}
      >
        {working ? "Cancelando..." : "Cancelar eliminación"}
      </button>
    </div>
  );
}
